import type { ElementType } from 'react';

const NATIVE_INTERACTIVE_TAGS = new Set([
  'button',
  'a',
  'input',
  'select',
  'textarea',
  'summary',
]);

// Native-activatable tags already fire onClick on Enter/Space; Box/Stack must
// skip them or it double-fires. Only string tags are knowable (custom -> false).
export function isNativeInteractiveElement(component: ElementType | undefined): boolean {
  return typeof component === 'string' && NATIVE_INTERACTIVE_TAGS.has(component);
}
